import React from 'react';
import { Icon } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/icon.less';

export default Icon;
